import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import { fileInputAccept } from '../../../../../constants/photo-upload';
import UploadIcon from '../../../../../components/icons/UploadIcon';
import videoExtensions from '../../../../../apps/pro/views/Upload/VideoUpload/helpers';
import { targetsSupportVideo } from '../../../../../apps/pro/views/AlbumFolder/AlbumFolderUpload/helpers';

const videoExtensionsType = videoExtensions
  .map(extension => `.${extension}`)
  .join(',');

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onUpload: PropTypes.func.isRequired,
};

const PhotoUploadStep = ({ album, onUpload }) => {
  const ref = useRef();
  const hasVideoUploadSupport = targetsSupportVideo({ targetAlbums: [album] });

  return (
    <Fragment>
      <h2 className="text-center mb-0">
        Select {hasVideoUploadSupport ? 'files' : 'photos'} for
      </h2>
      <h2 className="text-center text-primary">{album.name}</h2>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div
        tabIndex={0}
        role="button"
        className="photo-upload-step-cta"
        onClick={() => ref?.current?.click?.()}
      >
        <Button
          onClick={e => e.preventDefault()}
          className="d-flex align-items-center"
        >
          <UploadIcon color="#fff" size={16} className="mr-1" /> Select photos
          {hasVideoUploadSupport ? ' and videos' : ''} to upload
        </Button>
      </div>
      <input
        id="uploader"
        type="file"
        className="d-none"
        multiple
        accept={
          hasVideoUploadSupport
            ? [videoExtensionsType, fileInputAccept].join(',')
            : fileInputAccept
        }
        onChange={event => {
          onUpload([...event.target.files], album);
        }}
        ref={ref}
      />
    </Fragment>
  );
};

PhotoUploadStep.propTypes = propTypes;

export default PhotoUploadStep;
